/* BC LED Colours: swatch picking + gentle idle auto-cycle until the visitor interacts. */
(function () {
  function initSection(controls) {
    var swatches = Array.prototype.slice.call(controls.querySelectorAll('.bc-led__swatch'));
    if (!swatches.length) return;

    var stage = document.getElementById(swatches[0].dataset.target);
    if (!stage) return;

    var index = 0;
    var userEngaged = false;
    var timer = null;

    function apply(i) {
      index = (i + swatches.length) % swatches.length;
      var sw = swatches[index];
      stage.style.setProperty('--bc-led-color', sw.dataset.color);
      swatches.forEach(function (s) {
        s.classList.toggle('is-active', s === sw);
        s.setAttribute('aria-pressed', s === sw ? 'true' : 'false');
      });
    }

    swatches.forEach(function (sw, i) {
      sw.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      sw.addEventListener('click', function () {
        userEngaged = true;
        if (timer) clearInterval(timer);
        apply(i);
      });
    });

    apply(0);

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;

    // Auto-cycle only while the section is on screen and untouched.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !userEngaged && !timer) {
            timer = setInterval(function () {
              if (userEngaged) {
                clearInterval(timer);
                timer = null;
                return;
              }
              apply(index + 1);
            }, 2200);
          } else if (!entry.isIntersecting && timer) {
            clearInterval(timer);
            timer = null;
          }
        });
      },
      { threshold: 0.35 }
    );
    observer.observe(stage);
  }

  function init() {
    document.querySelectorAll('.bc-led__controls').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  // Re-init when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
